import { Component, OnInit } from "@angular/core";

import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

import { SmsServiceIndstillinger } from "./model/sms-service-indstillinger.model";
import { SmsServiceService } from "./shared/sms-service.service";

@Component({
    templateUrl: "./sms-service.component.html",
    styleUrls: ["./sms-service.component.scss"]
})
export class SmsServiceComponent implements OnInit {
    public vm$: Observable<SmsServiceIndstillinger>;

    constructor(private readonly service: SmsServiceService) {}

    public ngOnInit(): void {
        this.vm$ = this.service.hentIndstillinger().pipe(shareReplay(1));
    }
}
